import { render } from "./Pagination.vue?vue&type=template&id=26c969c0&scoped=true"
import script from "./Pagination.vue?vue&type=script&lang=js"
export * from "./Pagination.vue?vue&type=script&lang=js"

import "./Pagination.vue?vue&type=style&index=0&id=26c969c0&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-26c969c0"

export default script